import { Helmet } from '@dr.pogodin/react-helmet';
import { Link } from 'react-router';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import Functions from '../functions';
import './assets/pubmedpdf.css';
import PubmedPdfBreadcrumbs from './lib/PubmedPdfBreadcrumbs';
import PubmedPdfListItemPaper from './lib/PubmedPdfPaper';
import PubmedPdfUtils, { type PubmedPdfBreadcrumbsData } from './lib/PubmedPdfUtils';

interface Props {
    lang: MultiLang;
    authorId: number;
    year: number;
}

const PubmedPdfPapersByAuthor = (props: Props) => {
    const { lang, authorId, year } = props;
    const name = PubmedPdfUtils.getName();
    const mtitle = Functions.mlang(name, lang);
    const author = PubmedPdfUtils.getAuthor(authorId);
    if (author === null) {
        return <PageNotFound lang={lang} />;
    }
    const initial = PubmedPdfUtils.getInitial(author.name);
    const breadcrumbs: PubmedPdfBreadcrumbsData[] = [
        { id: `a-${initial}`, name: initial, link: PubmedPdfUtils.getAuthorInitialUrl(initial) },
        {
            id: `a.${authorId}`,
            name: Functions.mlang(author.name, lang),
            link: PubmedPdfUtils.getAuthorUrl(authorId, 0),
        },
    ];
    if (year !== 0) {
        breadcrumbs.push({ id: `y.${year}`, name: `${year}`, link: PubmedPdfUtils.getAuthorUrl(authorId, year) });
    }
    const papers = PubmedPdfUtils.getPapersByAuthorId(authorId, year);
    const years = PubmedPdfUtils.getYearsByPapers(papers);
    return (
        <div className="pubmedpdf">
            <Helmet>
                <title>
                    {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{mtitle}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <PubmedPdfBreadcrumbs lang={lang} breadcrumbs={breadcrumbs} />
            <hr />
            <div className="years">
                {years.map((year) => {
                    return (
                        <div className="year" key={year.year}>
                            <Link to={PubmedPdfUtils.getAuthorUrl(authorId, year.year)}>{year.year}</Link> ({year.count}
                            )
                        </div>
                    );
                })}
            </div>
            <hr />
            <div className="papers">
                {papers.map((paper) => {
                    return <PubmedPdfListItemPaper key={paper.id} lang={lang} paper={paper} />;
                })}
            </div>
        </div>
    );
};

export default PubmedPdfPapersByAuthor;
